<div class='row h-100 align-items-center justify-content-center'>
  <div class='col-12 h-100 text-center d-flex align-items-center justify-content-center'>
    <div *ngIf='isLoading' class='row text-center mb-2'>
      <i class='fa fa-spinner fa-spin fa-3x' aria-hidden='true'></i>
    </div>
    <span *ngIf='hasError && !isLoading' class='form-input-error-message'>{{errorMsg}}</span>
    <div [class.d-none]='isLoading || hasError' class='report-container' #reportContainer id='reportContainer'></div>
  </div>
</div>
